import Vue from "vue";
import Router from "vue-router";
import BareLayout from "../views/BareLayout";
import LoginForm from "../components/Base/LoginForm";
import BareLanding from "../views/BareLanding";
import projects from "./projects";
import zenkit from './zenkit';
import systems from "./systems";
import materials from "./materials";
import quality from "./quality";
import shipping from "./shipping";
import locations from "./locations";

Vue.use(Router);

const routes = [
  {
    path: "/",
    component: BareLayout,
    children: [
      {
        path: "",
        component: BareLanding,
        name: "Home"
      },
      {
        path: "Login",
        component: LoginForm,
        name: "Login",
        meta: {
          beforeResolve(routeTo, routeFrom, next) {
            // If the user is already logged in
            if (this.loggedIn) {
              // Redirect to the home page instead
              next({ name: "Home" });
            } else {
              // Continue to the login page
              next();
            }
          }
        }
      }
    ]
  },
  ...projects,
  ...zenkit,
  ...systems,
  ...materials,
  ...quality,
  ...shipping,
  ...locations,
  {
    path: "/404",
    name: "NotFound",
    component: require("../views/NotFound").default,
    // Allows props to be passed to the 404 page through route
    // params, such as `resource` to define what wasn't found.
    props: true
  },
  // Redirect any unmatched routes to the 404 page.
  {
    path: "*",
    redirect: "404"
  }
];

const router = new Router({
  routes,
  mode: "history",
  // Simulate native-like scroll behavior when navigating to a new
  // route and using back/forward buttons.
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return { x: 0, y: 0 };
    }
  }
});

router.beforeEach((to, from, next) => {
  const publicPages = ['/Home', '/Login', ''];
  const authRequired = !publicPages.includes(to.path);
  const loggedIn = localStorage.getItem('user');

  // trying to access a restricted page + not logged in
  // redirect to login page
  if (authRequired && !loggedIn) {
    next({ name: 'Login' });
  } else {
    next();
  }
});

export default router;
